<template>
  <div :data-pc-key="config.key" :class="getClass()" :style="getStyle()" draggable="true" :title="config.desc || config.text">
    <drop-position :text="getShowText()" :dropMode="dropMode1" @remove="triggerRemove" @clone="clone"></drop-position>
  </div>
</template>

<script>
import mixin from './mixin.js'

export default {
  name: 'common-text-component',
  mixins: [mixin],
  data () {
    return {
      dropMode1: 'before,after',
      displayText: '',
      properties: {
        text: ''
      }
    }
  },
  created () {
    this.dropMode1 = this.dropMode || 'before,after'
  },
  watch: {
    'properties.text' () {
      let displayText = this.properties.text
      if (displayText) {
        try {
          let dataSource = JSON.parse(displayText)
          if (dataSource && dataSource.id) {
            displayText = this.getText(dataSource)
          }
        } catch (e) {
          // do nothing
        }
      }
      this.displayText = displayText
    }
  },
  methods: {
    getShowText () {
      let showText = this.config.text
      if (this.displayText) {
        showText += ` - ${this.displayText}`
      }
      return showText
    },
    getText (dataSource) {
      let type = dataSource.type
      if (type === 'model') {
        return `数据源 - 模型: ${dataSource.name}`
      }
      if (type === 'dynamicForm') {
        return `数据源 - 动态表单: ${dataSource.name}`
      }
      if (type === 'apiDataSource') {
        return `数据源 - API数据源: ${dataSource.name}`
      }
      return dataSource.name
    }
  }
}
</script>
